import * as $ from "jquery";
import * as ko from "knockout";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import WorkItemCollectionDialog from "../dialogs/work-item-collection-dialog";
import WorkItemTypeDialog from "../dialogs/work-item-type-dialog";
import Guid from "./../../factories/guid";

/**
 * WorkItemTab view model for ConfigurationItem 
 */
class ConfigurationItemWorkItemTab extends GenericListSearchTab {
    // #region Constructor

    /**
     * Constructor
     * @param tabPage current tab page
     * @param parent ConfigurationItem
     */
    constructor(public tabPage: TabPage, parent: any) {
        super(tabPage, parent);
        this.Parent = parent;

        this.ConfigurationItemId(parent.ConfigurationItemId());

        this.Models.subscribe(() => {
            this.Selection([]);
        });

        this.ShowVirtual.subscribe(() => this.RefreshList());
        this.StartDateHtml.subscribe(() => this.RefreshList());
        this.EndDateHtml.subscribe((newValue) => {
            this.ChangingData = true;
            if (newValue === null) {
                this.ShowVirtual(false);
            }
            this.ChangingData = false;
            this.RefreshList();
        });
    }

    // #endregion

    // #Properties
    /**
     * (Filter) If true then show virtual items (WorkItems) on the list
     */
    ShowVirtual = ko.observable<boolean>(false);

    /**
     * Start date (filter)
     */
    StartDateHtml: KnockoutObservable<string> = ko.observable('');

    /**
     * End date (filter)
     */
    EndDateHtml: KnockoutObservable<string> = ko.observable('');

    /**
     * True if view is loeaded
     */
    IsLoaded: boolean = false;

    /**
     * If true, the date filters are currently being modified
     */
    ChangingData: boolean = false;

    /**
     * ConfigurationItemId of the tab
     */
    ConfigurationItemId: KnockoutObservable<string> = ko.observable('');

    /**
     * Url of Controller
     */
    ControllerUrl = "ConfigurationItemWorkItemTab";

    // #endregion

    /**
     * Key of SearchObject
     * @returns name of SearchObject key
     */
    SearchType() {
        return "WorkItemLegacy";
    }

    /**
     * Sets custom filters
     * @returns array of filters
     */
    CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];

        if (this.StartDateHtml()) {
            customFilterHashObject.push({
                Key: 'FromDate',
                Value: this.StartDateHtml()
            });
        }

        if (this.EndDateHtml()) {
            customFilterHashObject.push({
                Key: 'ToDate',
                Value: this.EndDateHtml()
            });
        }

        if (this.StartDateHtml() || this.EndDateHtml()) {
            customFilterHashObject.push({
                Key: 'DateFilterType',
                Value: 'ValidFrom'
            });
        }

        customFilterHashObject.push({
            Key: 'ShowVirtual',
            Value: this.ShowVirtual()
        });

        customFilterHashObject.push({
            Key: 'IsDirty',
            Value: this.TabPage.DirtyFlag()
        });

        return customFilterHashObject;
    }

    /**
     * ItemCompleteCheck
     * @returns
     */
    ItemCompleteCheck(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    /**
     * Initialization
     * @returns
     */
    init(): JQueryPromise<void> {
        return super.init()
            .then(() => { this.IsLoaded = true; });
    }

    /**
     * Refreshing list
     * @returns
     */
    RefreshList = () => {
        if (!this.IsLoaded || this.TabPage.DirtyFlag() || this.ChangingData) {
            return;
        }

        if (this.PageIndex() != 0) {
            this.PageIndex(0);
        }

        this.Get();
    };

    /**
     * Custom Logic if the Toolbar is clicked.
     * Used to create a new WorkItem directly from this Tab.
     */
    CustomToolbarClick(button: Interfaces.Bao.BaoMenuItem) {
        let key = ko.unwrap(button.ActionKey);

        if (key == "ConfigurationItemWorkItemTabNew") {

            let linkHash = "WorkItem/" + Guid() + "/null/null/" + this.ConfigurationItemId();
            baoRouter.setHash(linkHash);
        }
    }
}
export default ConfigurationItemWorkItemTab;